// Helper method to search through minimal home content array to match topic data with
// selected topic in URL parameters.  In use by App.js createAppBar method:
export const findTopicByUrlPath = (arr, incomingTopicPath) => {
    let foundTopic;

    arr.forEach((topic) => {
        // Search a topics subtopics if they exist. Currently only relevant to cancer:
        if (topic.subtopics) {
            topic.subtopics.forEach((sub) => {
                if (sub.topicUrlPath === incomingTopicPath) {
                    foundTopic = sub;
                }
            });
        } else if (topic.topicUrlPath === incomingTopicPath) {
            foundTopic = topic;
        }
    });

    return foundTopic;
};

// Method used to locate and return a theme and tab.
// Takes a locationInfo object formatted as follows: {theme: string, tab: string}.
// We work under the assumption that there will always be a theme and a tab provided,
// never just a theme alone.

// Used within the HealthTopic component:
export const findThemeAndTab = (topic, locationInfo) => {
    const foundTheme = topic.themes.find(
        (t) => t.themePath === locationInfo.theme
    );

    if (foundTheme) {
        const foundTab = foundTheme.tabs.find(
            (tab) => tab.tabPath === locationInfo.tab
        );

        return [foundTheme, foundTab];
    }
    return null;
};

// Method to configure endpoint URLs for environments in the topic configuration JSON.
// Add the appropriate base URL to the relative URIs for each environment and content type, unless the endpoint is external
// to the EPHT API or MapServices. For example, MD IMAP URLs are external and not altered as the database configuration
// holds the full URL and this will not vary with environment.
// Params: jsonConfig - the JSON object to update, parentContext - the context object to pass down to child objects
export const setUrlsForEnvironment = (jsonConfig, parentContext = {}) => {
    // Process arrays, passing the current context
    if (Array.isArray(jsonConfig)) {
        return jsonConfig.map((item) =>
            setUrlsForEnvironment(item, parentContext)
        );
    }

    // Process objects
    if (jsonConfig && typeof jsonConfig === 'object') {
        const currentContext = { ...parentContext };

        // Update the context so we can identify the contentType for the current object
        if (
            'contentType' in jsonConfig &&
            typeof jsonConfig.contentType === 'string'
        ) {
            currentContext.contentType = jsonConfig.contentType;
        }

        // Build the updated object by iterating over its entries
        return Object.fromEntries(
            Object.entries(jsonConfig).map(([key, value]) => {
                if (
                    key === 'url' &&
                    typeof value === 'string' &&
                    value.startsWith('/') // We only modify relative URLs
                ) {
                    // Modify the URL based on the current contentType
                    let updatedUrl;
                    if (currentContext.contentType === 'map') {
                        updatedUrl = `${process.env.REACT_APP_MAP_SERVICE}${value}`; // Use the MapService API endpoint
                    } else {
                        updatedUrl = `${process.env.REACT_APP_EPHT_API}${value}`; // Charts and tables use the EPHT API endpoint
                    }
                    return [key, updatedUrl];
                }

                // Recursively process nested objects, passing the current context
                return [key, setUrlsForEnvironment(value, currentContext)];
            })
        );
    }

    // If here, the value is a primitive so we return it as-is
    return jsonConfig;
};
